import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { ILoyaltyHistoryData, ILoyaltyHistoryResponse } from "../types";
import { LoyaltyService } from "../../services/loyalty.service";

export const useGetLoyaltyHistoryQuery = (data: ILoyaltyHistoryData) => {
  return useQuery<ILoyaltyHistoryResponse, Error>({
    queryKey: [QUERY_CONSTANTS.GET_LOYALTY_HISTORY, data],
    queryFn: () => LoyaltyService.getLoyaltyHistory(data).then((res) => res.data),
    enabled: !!data?.userId,
  });
};
